import { IdentifiableBase } from './identifiable-base.model';
import { Address, AddressImpl } from './person.model';


export interface Employer extends IdentifiableBase {
  employerName: string;
  cui: string;
  address: Address;
  emailHr: string;
  phoneNumber: string;
}

export class EmployerImpl implements Employer {
  uuid = '';
  employerName = '';
  cui = '';
  address = new AddressImpl()
  emailHr = '';
  phoneNumber = '';
}

export const NEW_EMPLOYER_ID = 'new';

